var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightCareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "95vtw735ya",
    d: "M0 0h5.927v6.07H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "957bryfwxc",
    d: "M0 0h12.873v19.963H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5lrizb5qne",
    d: "M0 0h11.88v19.963H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .054)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F6F8FA",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.23 12.946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.963 2.34a2.472 2.472 0 0 0-.301 1.182c0 1.407 1.178 2.549 2.632 2.549 1.454 0 2.633-1.142 2.633-2.549S4.747.974 3.294.974c-.3 0-.586.051-.855.14A1.204 1.204 0 0 0 1.223 0C.548 0 0 .53 0 1.184c0 .568.413 1.041.963 1.156",
    fill: "currentColor",
    mask: "url(#unus518lwb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 18.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.873 1.05-2.716 1.842L8.754.934v.003a2.245 2.245 0 0 0-.722-.64C6.937-.314 5.537.049 4.906 1.11L1.719 6.445a2.187 2.187 0 0 0-.26.667h-.002S.157 12.862.01 13.51c-.149.648 1.564 1.298 2.98 1.589.307.062.71.128 1.148.186l-.481 3.374c-.11.604.308 1.182.932 1.287.623.107 1.22-.296 1.329-.902l.657-3.602c.717-.022 1.247-.138 1.277-.418v-9.99l.746-1.25L9.63 4.957c.18.235.694.337 1.03-.194l.38-.638 1.833-3.076z",
    fill: "currentColor",
    mask: "url(#4pwdw52bpd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.23 19.017c1.453 0 2.633-1.141 2.633-2.548 0-1.408-1.18-2.548-2.633-2.548-1.454 0-2.633 1.14-2.633 2.548 0 1.407 1.179 2.548 2.633 2.548",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.12 18.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.455 7.046-3.08-1.72-.615-3.187a2.18 2.18 0 0 0-.125-.65l-.002-.005A2.222 2.222 0 0 0 6.619.299c-1.095-.613-2.496-.25-3.127.81L.305 6.446a2.152 2.152 0 0 0-.047 2.127l-.002.002 2.717 4.957-.73 5.128c-.11.604.307 1.182.93 1.287.624.107 1.221-.296 1.33-.902l.959-5.26c.17-.925-.1-1.322-.733-2.688L3.874 9.15c.152-.141.287-.303.398-.488l2.235-3.743.163.571c.113.536.321.966.661 1.156l3.272 1.828a.867.867 0 0 0 1.164-.301.81.81 0 0 0-.312-1.126",
    fill: "currentColor",
    mask: "url(#v21bu4t4ff)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.77 38.465v-9.46a.401.401 0 0 0-.406-.394.401.401 0 0 0-.407.394c0 .265-.223.48-.497.48a.489.489 0 0 1-.496-.48c0-.748.627-1.356 1.4-1.356.772 0 1.4.608 1.4 1.356v9.46c0 .266-.222.481-.497.481a.489.489 0 0 1-.497-.48z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightCareIcon);
export default __webpack_public_path__ + "static/media/highlightCareIcon.368147db49704ed78c50bd1f2fe88b6a.svg";
export { ForwardRef as ReactComponent };